<template>
  <div class="pc-main">
    <div :style="{ 'position': 'absolute', 'left': 0, 'right': 0 }">
      <div style="display: flex; justify-content: space-between;">
        <div :style="{ width: paddingAuto}"></div>
        <div class="header">
          <div class="logo" @click="jumpPath('/')"><img src="../../assets/logo.png" alt=""></div>
          <div class="menu">
            <div style="display: flex">
              <div class="products" @click="jumpPath('products')"><a>{{ zh === 'ja' ? zhJson.header.ja[0] : zhJson.header.en[0] }}</a></div>
              <div class="clients" @click="jumpPath('clients')"><a>{{ zh === 'ja' ? zhJson.header.ja[1] : zhJson.header.en[1] }}</a></div>
            </div>
            <div style="display: flex">
<!--              <div>-->
                <el-dropdown @command="handleZh">
                  <span class="el-dropdown-link">{{ zh === 'ja' ? '日本語' : 'English' }}<i class="el-icon-arrow-down el-icon--right"></i></span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="en">English</el-dropdown-item>
                    <el-dropdown-item command="ja">日本語</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
<!--              </div>-->
              <div class="contact" @click="jumpPath('/', 'contact')">
                <a href="#contact">{{ zh === 'ja' ? zhJson.header.ja[2] : zhJson.header.en[2] }}</a><img src="../../assets/icon-1-1.png" alt="" style="margin-left: 7px">
              </div>
            </div>
          </div>
        </div>
        <div  :style="{ width: paddingAuto}"></div>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "index",
  components: {},
  props: {},
  computed: {},
  watch: {
    screenWidth: function (n, o) {
      if (n <= 1280) {
        this.headerWidth = 1280 + 'px';
      } else if (n >= 1920) {
        this.headerWidth = 1920 + 'px';
      } else {
        this.headerWidth = n + 'px';
      }
    },
  },
  data() {
    return {
      paddingAuto: null,
      screenWidth: null,
      headerWidth: null,
      zh: '',
      zhJson: {
        header: {
          en: ['Products', 'Our Clients', 'Contact Us'],
          ja: ['製品情報', '導入事例', 'お問い合わせ']
        },
      }
    }
  },
  methods: {
    handleZh(command) {
      if (this.zh !== command) {
        this.zh = command;
        this.$router.push({ path: this.$route.path, query: {'zh': command} });
      }
    },
    jumpPath(path, id) {
      this.$router.push({ path: path, query: {'zh': this.zh, 'id': id} });
    },
  },
  mounted() {
    if (this.$route.query.zh && (this.$route.query.zh === 'en' || this.$route.query.zh === 'ja')) {
      this.zh = this.$route.query.zh;
    } else {
      this.zh = 'en';
    }
    this.screenWidth = document.body.clientWidth;
    if (this.screenWidth - 1040 >= 0) {
      this.paddingAuto = (this.screenWidth - 1040) / 2 + 'px';
    }
    if (this.screenWidth <= 1280) {
      this.headerWidth = 1280 + 'px';
    } else if (this.screenWidth >= 1920) {
      this.headerWidth = 1920 + 'px';
    } else {
      this.headerWidth = this.screenWidth + 'px';
    }
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
  }
}
</script>

<style lang="less" scoped>
  .pc-main {
    max-width: 1920px;
    min-width: 1280px;
    overflow-x: hidden;
    margin: auto;
  }

  .header {
    width: 1040px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 44px;

    .logo {
      cursor: pointer;
      img {
        width: 215px;
        height: 33px;
      }
    }

    .menu {
      margin-left: 29px;
      width: 787px;
      height: 46px;
      background: linear-gradient(89.87deg, #25BBDE -4.17%, #11ECA0 99.92%, #11ECA0 99.92%);
      box-shadow: 5px 5px 20px 3px rgba(22, 244, 167, 0.16);
      border-radius: 86px;

      font-family: 'Poppins-SB',serif;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 139%;
      letter-spacing: 0.03em;
      color: #FFFFFF;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .products {
        margin-left: 70px;
        cursor: pointer;
        a:hover {
          //text-decoration: underline;
          text-shadow: 1px 1px 10px rgba(255, 255, 255, 0.8), 2px 2px 20px #FFFFFF;
        }
      }
      .clients {
        margin-left: 60px;
        cursor: pointer;
        a:hover {
          //text-decoration: underline;
          text-shadow: 1px 1px 10px rgba(255, 255, 255, 0.8), 2px 2px 20px #FFFFFF;
        }
      }

      .el-dropdown-link {
        cursor: pointer;
        color: #FFFFFF;
      }

      .contact {
        margin-left: 30px;
        margin-right: 54px;
        cursor: pointer;
        a:hover {
          //text-decoration: underline;
          text-shadow: 1px 1px 10px rgba(255, 255, 255, 0.8), 2px 2px 20px #FFFFFF;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/pc/index.vue